import { PROD_BY_HOST_NAME, PROD_COM_HOST_NAME, YM_ID_BY, YM_ID_COM, YM_ID_TEST } from './consts';

export const isRoistatReady = (win: Window): win is typeof win & { roistat: { getVisit: () => string } } => {
  const roistat = (win as any).roistat;

  return roistat && typeof roistat.getVisit === 'function';
};

export const getYaId = () => {
  if (window.location.hostname === PROD_BY_HOST_NAME) {
    return YM_ID_BY;
  }

  if (window.location.hostname === PROD_COM_HOST_NAME) {
    return YM_ID_COM;
  }

  return YM_ID_TEST;
};
